import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import { filterServicesByDate, filterServicesByMealPlan, filterServicesByDistribution } from './utils';

import ListContainer from './ListContainer';

import './ServicesManager.css';

const ServicesManager = (props) => {
  const [servicesList, setServicesList] = useState([]);

  const {
    reservationId,
    fromDate,
    toDate,
    roomsList,
    availableServicesList,
    readOnly
  } = props;

  useEffect(() => {
    if (!availableServicesList || availableServicesList.length === 0) {
      setServicesList([]);
      return;
    }

    const filteredServices = filterServicesByDate(fromDate, toDate, availableServicesList);

    setServicesList(filteredServices);
  }, [props.fromDate, props.toDate, props.availableServicesList]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAddReservationService = (roomId, service) => {
    props.handleAddService(reservationId, roomId, service);
  };

  const handleDeleteReservationService = (roomId, serviceId) => {
    props.handleDeleteService(reservationId, roomId, serviceId);
  };

  const handleUpdateReservationService = (roomId, serviceData) => {
    props.handleUpdateService(reservationId, roomId, serviceData);
  };

  const filterServiceByRoom = (distribution, boardCode) => {
    let finaList = servicesList;

    finaList = filterServicesByDistribution(distribution, finaList);

    finaList = filterServicesByMealPlan(boardCode, finaList);

    return finaList;
  };

  return (
    <Container>
      {
        roomsList.map((room) => {
          const {
            id,
            boardCode,
            distribution,
            services
          } = room;

          return (
            <ListContainer
              key={id}
              roomId={id}
              distribution={distribution}
              availableServicesList={filterServiceByRoom(distribution, boardCode)}
              servicesList={services}
              readOnly={readOnly}
              handleNewService={handleAddReservationService}
              handleDeleteService={handleDeleteReservationService}
              handleUpdateService={handleUpdateReservationService}
            />
          );
        })
      }
    </Container>
  );
};

ServicesManager.propTypes = {
  reservationId: PropTypes.number.isRequired,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  roomsList: PropTypes.arrayOf(PropTypes.object),
  availableServicesList: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  handleAddService: PropTypes.func,
  handleDeleteService: PropTypes.func,
  handleUpdateService: PropTypes.func
};

ServicesManager.defaultProps = {
  fromDate: '',
  toDate: '',
  roomsList: [],
  availableServicesList: [],
  readOnly: false,
  handleAddService: () => {},
  handleDeleteService: () => {},
  handleUpdateService: () => {}
};

export default React.memo(ServicesManager);
